import React from 'react';

const PdpRespExitModalLazyComponent = React.lazy(() =>
    import(/* webpackChunkName: "PdpRespExitModal" */ './PdpRespExitModal')
);

export const PdpRespExitModalLazy = props => (
    <React.Suspense fallback="">
        <PdpRespExitModalLazyComponent {...props} />
    </React.Suspense>
);
